import { defineStore } from 'pinia';

export const useOptionsStore = defineStore('options', {
    state: () => ({ options: {} }),
    getters: {
        getOption(key){
            this.options[key]
        }
    },
    actions: {
        setOption(key, value){
            this.options[key] = value;
            return value;
        },
        watchOption(key, param, value){
            return {"key": key, "param": param, "value": value};
        },
        fill(datas){
            this.options = datas;
        }
    }

});